import { gql } from '@apollo/client';

export const SUBMIT_CONTACT = gql`
  mutation SubmitContact($input: ContactInput!) {
    submitContact(input: $input) {
      success
      message
      emailResults {
        adminEmail {
          success
          messageId
          error
        }
        userEmail {
          success
          messageId
          error
        }
      }
    }
  }
`;